import { httpClient } from "@bw/shared/api";
import type { OrgResponse, PlatformOrgCreate, ReviewNoteResponse, UUID } from "@bw/shared/types";
import type { PlatformOnboardingPipeline } from "@bw/shared/types/generated";

export async function listOnboardingOrgs(): Promise<PlatformOnboardingPipeline> {
  return httpClient.get<PlatformOnboardingPipeline>("/platform/onboarding");
}

export async function startReview(orgId: UUID): Promise<void> {
  return httpClient.post<void>(`/platform/orgs/${orgId}/start-review`);
}

export async function rejectOrg(orgId: UUID, reason: string): Promise<void> {
  return httpClient.post<void>(`/platform/orgs/${orgId}/reject`, { reason });
}

export async function reactivateOrg(orgId: UUID): Promise<void> {
  return httpClient.post<void>(`/platform/orgs/${orgId}/reactivate`);
}

export async function createOrg(data: PlatformOrgCreate): Promise<OrgResponse> {
  return httpClient.post<OrgResponse>("/platform/orgs/create", data);
}

export async function addNote(
  orgId: UUID,
  note: string,
  noteType?: string,
): Promise<ReviewNoteResponse> {
  return httpClient.post<ReviewNoteResponse>(`/platform/orgs/${orgId}/notes`, {
    note,
    ...(noteType ? { note_type: noteType } : {}),
  });
}

export async function getNotes(orgId: UUID): Promise<ReviewNoteResponse[]> {
  return httpClient.get<ReviewNoteResponse[]>(`/platform/orgs/${orgId}/notes`);
}
